"use client";
import React, { createContext, useState } from "react";
import SecondaryButton from "@/components/ui/secondary-button";
import MobileNavigationItem from "@/components/ui/navigation/mobile-navigation-item";
import { navItems } from "@/lib/data";
import { Menu, Phone, X } from "@/components/icons";
import Angel from "@/logos/angel";
import { useScrollY } from "@/hooks/use-scroll-y";
import { CALLRAIL_HREF, CALLRAIL_PRETTY, cn } from "@/lib/utils";
import Link from "next/link";
import LINKS from "@/lib/links";
import { NavItem } from "@/lib/data";

export const MenuContext = createContext({ closeMenu: () => {} });

export interface MobileNavigationProps {
  className?: string;
  links?: NavItem[];
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  className,
  links,
}) => {
  const mobileNavItems = links ?? navItems;
  const [menuOpen, setMenuOpen] = useState(false);
  const openMenu = () => setMenuOpen(true);
  const closeMenu = () => setMenuOpen(false);
  const visible = useScrollY();

  return (
    <nav
      className={cn(
        className,
        "top-0 transition-transform",
        visible ? "translate-y-0" : "-translate-y-full"
      )}
    >
      <div className="flex h-16 flex-row items-center justify-between border-b border-b-neutral-200 bg-white p-4">
        {menuOpen ? (
          <X
            aria-label="close menu"
            className="cursor-pointer select-none"
            onClick={closeMenu}
          />
        ) : (
          <Menu
            aria-label="open menu"
            className="cursor-pointer select-none"
            onClick={openMenu}
          />
        )}
        <SecondaryButton
          size="sm"
          color="orange"
          className="flex flex-row items-center gap-2 py-2"
          asChild
        >
          <a
            href={CALLRAIL_HREF}
            id="hotline-mobile-navbar"
          >
            <Phone className="size-3 transition-colors md:size-4" />
            {CALLRAIL_PRETTY}
          </a>
        </SecondaryButton>
        <Link
          onClick={closeMenu}
          href={LINKS.homepage.href}
        >
          <Angel />
        </Link>
      </div>
      <MenuContext.Provider value={{ closeMenu }}>
        {menuOpen && (
          <ul className="fixed flex h-[calc(100vh-4rem-1px)] w-full flex-col overflow-y-scroll bg-white pr-2">
            {mobileNavItems.map((item) => {
              return (
                <MobileNavigationItem
                  key={item.nest + "-" + item.href}
                  href={item.href}
                  displayName={item.displayName}
                  subMenu={item.subMenu}
                />
              );
            })}
          </ul>
        )}
      </MenuContext.Provider>
    </nav>
  );
};

export default MobileNavigation;
